const GovEnrolmentsEmpty = ({ children }) => children

export default GovEnrolmentsEmpty



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccms-gov-enrolments/views/empty.jsx